import { render } from "./SocialMedia.vue?vue&type=template&id=4ff07e00&scoped=true"
import script from "./SocialMedia.vue?vue&type=script&lang=js"
export * from "./SocialMedia.vue?vue&type=script&lang=js"

import "./SocialMedia.vue?vue&type=style&index=0&id=4ff07e00&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff07e00"]])

export default __exports__